import { onUnmounted, ref } from '@nuxtjs/composition-api';
import { useIntersectionObserver } from '@vueuse/core';

/**
 * Infinite Scroll Hook
 *
 * @param {function} cb callback to execute
 * @param {Object} options Intersection Api Options
 *
 * @returns {target, stopObserver}
 */
export const useInfiniteScroll = (cb, options) => {
  const target = ref(null);

  const { stop } = useIntersectionObserver(
    target,
    ([{ isIntersecting }]) => {
      if (isIntersecting) {
        cb();
      }
    },
    options
  );

  onUnmounted(() => {
    stop();
  });

  return [target, stop];
};
